import { CLEAR_ORDER_HISTORY } from '../constants/ActionTypes'

export function clearOrderHistory(category) {
    return {
        type: CLEAR_ORDER_HISTORY,
        payload: category
    }
}
